module.exports = __webpack_public_path__ + "img/entryway-accents-decor.3aa8bfe.jpg";